import { useTranslation } from 'react-i18next';
import {
  WarningReason,
  EngagementCampaignPostStatus,
  EngagementCampaignSocialAccountPostStatus
} from '@anytag/graphql';
import { Badge, BadgeProps } from '@anyui/core';
import { useGetPostWarningReasonStatusProps } from '../shared';

export interface EngagementPostStatusProps {
  className?: string;
  warningReason?: WarningReason;
  status: EngagementCampaignPostStatus | EngagementCampaignSocialAccountPostStatus;
}

export const EngagementPostStatus = ({ status, warningReason, className }: EngagementPostStatusProps) => {
  const { t } = useTranslation();
  const { getPostWarningReasonStatusProps } = useGetPostWarningReasonStatusProps();

  const hasReason = status === EngagementCampaignPostStatus.WARNING && !!warningReason;
  const statusProps: BadgeProps = (() => {
    if (hasReason) {
      return getPostWarningReasonStatusProps(warningReason);
    } else {
      switch (status) {
        case EngagementCampaignPostStatus.REVIEWING:
          return { children: t('Option.Reviewing'), color: 'purple' };
        case EngagementCampaignPostStatus.READY_TO_POST:
          return { children: t('Option.Ready to Post'), color: 'green' };
        case EngagementCampaignPostStatus.EFFECTIVE:
          return { children: t('Option.Effective'), color: 'green' };
        case EngagementCampaignPostStatus.WARNING:
          return { children: t('Option.Warning'), color: 'red' };
        case EngagementCampaignPostStatus.WARNING_SOLVED:
          return { children: t('Option.Effective'), color: 'green' };
        case EngagementCampaignPostStatus.APPROVED:
          return { children: t('Option.Approved'), color: 'green' };
        case EngagementCampaignPostStatus.INEFFECTIVE:
          return { children: t('Option.Ineffective'), color: 'zinc' };
        case EngagementCampaignPostStatus.REJECT:
          return { children: t('Option.Rejected'), color: 'zinc' };
        case EngagementCampaignPostStatus.TTCM_REVIEWING:
          return { children: t('Option.TikTok Review'), color: 'yellow' };
        case EngagementCampaignSocialAccountPostStatus.JOINED:
        case EngagementCampaignSocialAccountPostStatus.JOINED_WITH_PENDING_ORDER:
        case EngagementCampaignSocialAccountPostStatus.JOINED_WITH_PENDING_INVITATION:
          return { children: t('Option.Joined'), color: 'blue' };
        default:
          return { children: null, color: 'zinc' };
      }
    }
  })();

  return <Badge {...statusProps} className={className} />;
};
